import React, { useState, Fragment } from "react";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import DialogContentModal from "../components/DialogContent";
// import ApplicaionFormatView from "../../Forms/ApplicationView";
// import PaymentPrint from "@egovernments/digit-ui-module-obps/src/pages/employee/PaymentSlipEmpAll/payment/PaymentSlip";
// import NOCFormatView from '../../Forms/NOCFormatView'
import ApplicaionFormatView from "../../Forms/ProfessionalForm/ApplicationSummary";
import RegistrationSummary from "../../Forms/ProfessionalForm/RegistrationSummary";
import LTPSummary from "@egovernments/digit-ui-module-obps/src/pages/citizen/AVPForms/formComponents/ltp-registration/Summary/LTPSummary";


const EmployeeComponent = ({ formData, applicationDocs, totalAmount }) => {
  // let user = Digit.UserService.getUser();
  const [smShow, setSmShow] = useState(false);
  // const [smShowNoc, setSmShowNoc] = useState(false);
  const [smShowPayment, setSmShowPayment] = useState(false);
  const { t } = useTranslation();
  // console.log("applicationData444444444", formData, applicationDocs);
  return (
    <React.Fragment>
      <div style={{ backgroundColor: "#eeeab5b0", padding: "10px" }}>
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)">
          <Box gridColumn="span 2">
            <b>{t(`BPA_APPLICATION_NUMBER_LABEL`)}</b>
          </Box>
          <Box gridColumn="span 3">
            : &nbsp;&nbsp;&nbsp;{formData?.applicationNumber || ""}
          </Box>
          <Box gridColumn="span 3">
            {/* <button
              className="btn btn-primary"
              style={{ padding: "1px" }}
              onClick={() => {
                setSmShow(true),
                  console.log("modal open")
              }}
            >
              View Application
            </button>  */}
          </Box>
          <Box gridColumn="span 4">
            {formData?.paymentStatus === "Success" && (
              <button
                className="btn btn-primary"
                style={{ padding: "1px" }}
                onClick={() => {
                  setSmShowPayment(true),
                    console.log("modal open")
                }}
              >
                Payment Receipt
              </button>
            )}
          </Box>

          <Box gridColumn="span 2">
            <b>Mobile Number</b>
          </Box>
          <Box gridColumn="span 10">

            {formData?.tradeLicenseDetail?.owners && formData?.tradeLicenseDetail?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp; {ob?.mobileNumber}
              </div>
            ))}

          </Box>
          <Box gridColumn="span 2" >
            <b>Applicant Name</b>
          </Box>
          <Box gridColumn="span 10">

            {formData?.tradeLicenseDetail?.owners && formData?.tradeLicenseDetail?.owners?.map((ob, index) => (
              <div>
                : &nbsp;&nbsp;&nbsp;{ob?.initialForApplicantName}&nbsp;{ob?.name}
              </div>
            ))}
          </Box>
          <Box gridColumn="span 2">
            <b>Service </b>
          </Box>
          <Box gridColumn="span 10">
            <div>
              : &nbsp;&nbsp; {t("FASTPAS.GLOBAL.TPR.TEXT")}
            </div>

          </Box>
        </Box>

        <DialogContentModal
          title={"Application Details"}
          dataOpen={smShow}
          onClose={() => { setSmShow(false) }}
        >
          <LTPSummary
            formData={formData}
            applicationDocs={applicationDocs}
            totalAmount={totalAmount}
          />
        </DialogContentModal>
        {/* <DialogContentModal
            title={"Application Details"}
            dataOpen={smShowNoc}
            onClose={() => { setSmShowNoc(false) }}
          >  
        <NOCFormatView
          formData={formData}
          applicationDocs={applicationDocs}
          totalAmount={totalAmount}
        />
          </DialogContentModal>

          <DialogContentModal
            title={"Application Payment Details"}
            dataOpen={smShowPayment}
            onClose={() => { setSmShowPayment(false) }}
          >
            <PaymentPrint
              id={formData?.applicationNo}
            />
          </DialogContentModal> */}

      </div>

    </React.Fragment>
  )
}
export default EmployeeComponent;